export const chatbotQueryKeys = {
  all: ['chatbots'] as const,
  list: () => [...chatbotQueryKeys.all, 'list'] as const,
  chatbot: (chatbotId: string) =>
    [...chatbotQueryKeys.all, 'chatbot', chatbotId] as const,
  conversations: (
    chatbotId: string,
    listOptions?: { limit: number; offset: number },
  ) =>
    [
      ...chatbotQueryKeys.chatbot(chatbotId),
      'conversations',
      listOptions ?? null,
    ] as const,
  conversation: (chatbotId: string, conversationId: string) =>
    [
      ...chatbotQueryKeys.conversations(chatbotId),
      'conversation',
      conversationId,
    ] as const,
  conversationMessages: (chatbotId: string, conversationId: string) =>
    [
      ...chatbotQueryKeys.conversation(chatbotId, conversationId),
      'messages',
    ] as const,
  conversationMessagesPages: (chatbotId: string, conversationId: string) =>
    [
      ...chatbotQueryKeys.conversationMessages(chatbotId, conversationId),
      'pages',
    ] as const,
  trainingExamples: (
    chatbotId: string,
    listOptions?: {
      limit: number;
      offset: number;
      search?: string;
      sort?: string;
    },
  ) =>
    [
      ...chatbotQueryKeys.chatbot(chatbotId),
      'trainingExamples',
      listOptions ?? null,
    ] as const,
  trainingExample: (chatbotId: string, exampleId: string) =>
    [
      ...chatbotQueryKeys.chatbot(chatbotId),
      'trainingExamples',
      'example',
      exampleId,
    ] as const,
  members: (chatbotId: string) =>
    [...chatbotQueryKeys.chatbot(chatbotId), 'members'] as const,
};
